<template>
    <modal v-if="isOpen" class-name="fleet-hub-modal" @close="closeModal">
      <template #body>
        <div>
          <h1 class="page-headline">
            Bereitstellungspauschale
          </h1>
          <p style="margin-bottom:10px;">
            PKW.de veranschlagt eine Bereitstellungspauschale für B2B-Kunden je Fahrzeug, zuzüglich Transportkosten (abhängig der gewählten Lieferart und Distanz).
          </p>
          <p style="margin-bottom:5px;"><strong>Unser Mehrwert für Sie:</strong></p>
          <ul class="styled-list">
            <li>Vorab-Fahrzeugcheck durch das PKW.de Team (Verfügbarkeit, Historie, optischer / technischer Zustand und Servicebedarf)</li>
            <li>Prüfung der Verträge und Abgleich mit Angaben aus dem Inserat (Unfallfreiheit, Mietwagen, EU-Wagen, etc.); der Kaufvertrag wird in der Regel dann mit PKW.de direkt geschlossen</li>
            <li>Finanzierungsangebot wenn gewünscht</li>
            <li>Organisation der Zulassungsunterlagen und deren Prüfung (Zulassungsservice gegen Aufpreis möglich)</li>
            <li>Organisation und Durchführung der Lieferung (gegen Aufpreis)</li>
          </ul>
        </div>
      </template>
    </modal>
  </template>
  
  <script>
  import Modal from '../common/Modal';
  
  export default {
    components: {
      Modal,
    },
    props: ['isOpen', 'closeModal'],
  };
  </script>
  